import { useRestoreTasks } from 'features/tasks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Undo } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { Task } from 'shared/types/task';

type Props = {
  task: Task;
  onClose: () => void;
};

export const RestoreList: React.FC<Props> = ({ task, onClose }) => {
  const { t } = useTranslation();
  const restoreTask = useRestoreTasks();

  const handleRestore = async () => {
    await restoreTask([task]);
    onClose();
  };

  return (
    <PopupMenuList hasBottomBorder>
      <PopupMenuListItem>
        <PopupMenuButton onClick={handleRestore} start={<Icon icon={Undo} />}>
          {t('context-menus.task.labels.restore')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
